import request from '../../../common/RemoteApiService';


const baseUrl = window.reportsConfig.api.baseUrl;
const endpoints = window.reportsConfig.api.endpoints;

const downloadReport = async (merchant, report, options = {}) => {

  const outputFormat = options.outputFormat || 'png';

  const response = await request('GET', endpoints.reports.download(baseUrl, merchant, report, outputFormat, options), null, {
    responseType: options.outputFormat !== 'json' && options.outputFormat !== 'html' ? 'blob' : '',
  });

  return response;
};

const getParameterValues = async (merchant, report, parameter) => {
  const response = await (await request('GET', endpoints.reports.getParameterValues(baseUrl, merchant, report, parameter)));

  return response.json();
};

const responseAsImage = async (request, img) => {
  var blob = await request.blob();

  var url = window.URL || window.webkitURL;
  img.src = url.createObjectURL(blob);
};

const responseAsDownloadable = (request) => {
  // get binary data as a response
  var blob = request.response;

  // Get the filename part
  var header = request.getResponseHeader('Content-disposition');
  var filenamePart = header.split(';')[1].trim().split('=')[1];
  // Remove quotes
  let filename = filenamePart.replace(/"/g, '');

  var url = URL.createObjectURL(new Blob([blob], { type: 'octet/stream' }));

  var a = document.createElement("a");
  a.style = "display: none";
  document.body.appendChild(a);

  a.href = url;
  a.download = filename;
  a.target = '_blank';

  a.click();
  window.URL.revokeObjectURL(url);
};


export {
  downloadReport,
  getParameterValues,
  responseAsImage,
  responseAsDownloadable
};

